import React, { Component } from 'react';
import PostCATolyptica from './PostCATolyptica';
import './App.css';

class App extends Component {
  render() {
    return (
      <PostCATolyptica />
    );
  }
}

export default App;
